import { useEffect, useContext } from 'react';
import styled from 'styled-components';

// common component
import LoadingCircle from '@src/components/common/LoadingCircle';

// context
import { UserContext } from '@src/context/UserContext';

// helper
import { goToKeyplayPageWithHref } from '@src/utils/helper';

// library

// route config
import { keyplayRoute } from '@src/config/staticRouteConfig';

import * as api from '../../common/api';

const GoogleAuth = () => {
  const { loginUser } = useContext(UserContext);

  useEffect(() => {
    (async () => {
      const { search } = window.location;
      const params = new URLSearchParams(search);

      const accessToken = params.get('accessToken');
      const refreshToken = params.get('refreshToken');
      const loginReturnUri = params.get('login_return_url');

      // login return uri
      const pageReturnURI = loginReturnUri;

      try {
        if (accessToken && refreshToken) {
          loginUser({
            accessToken: accessToken,
            refreshToken: refreshToken,
          });
          window.location.href = decodeURIComponent(pageReturnURI)
            ? decodeURIComponent(pageReturnURI)
            : '/';
        }
      } catch (err) {
        goToKeyplayPageWithHref('로그인에 실패하였습니다.', keyplayRoute.login);
      }
    })();
  }, []);

  return (
    <Container>
      <LoginLoadingCircleWrap className="LoginLoadingCricleWrap">
        <LoginLoadingCricle
          className="LoginLoadingCricle"
          viewBox="0 0 80 80"
          isLoading
        />
      </LoginLoadingCircleWrap>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  filter: opacity(0.6) blur(3px);
`;

const LoginLoadingCircleWrap = styled.div`
  text-align: center;
  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    width: 80%;
  }
`;
const LoginLoadingCricle = styled(LoadingCircle)`
  width: 100%;
`;

export default GoogleAuth;
